export const setErrorMessage = (message: string): void => {
	window.setMessage(message, 'error');
}